import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {PictureService} from './picture.service';

@Component({
    selector: 'surface-picture',
    templateUrl: './picture.component.html',
    styleUrls: ['./picture.component.css']
})
export class PictureComponent implements OnInit {
    @ViewChild('divElement', {static: true}) divElement: any;

    @ViewChild('pictureCanvas', {static: true})
    private _pictureCanvasRef: ElementRef;
    private _width: number;
    private _height: number;

    constructor(public _pictureService: PictureService) {
        this._width = 0;
        this._height = 0;
    }

    ngOnInit() {
        this._pictureService.pictureCanvas = this._pictureCanvasRef.nativeElement;
    }

    // public onResize() {
    //     if (this.divElement && this.divElement.nativeElement) {
    //         const el: HTMLDivElement = this.divElement.nativeElement;
    //         const width = el.clientWidth;
    //         let modelHeight = el.clientHeight - el.offsetTop;
    //
    //         if (width > 0 && modelHeight > 0) {
    //             // remove slider space on small devices
    //             // if (this._smallScreenSize) {
    //             //     modelHeight += el.offsetTop;
    //             // }
    //             // this.canvas.clientWidth=window.innerWidth;
    //
    //             this.pictureCanvas.width = width;
    //             this.pictureCanvas.modelHeight = modelHeight;
    //             // this.containerService.canvasWidth = width;
    //             // this.containerService.canvasHeight = modelHeight;
    //             this.boundingRect = this.pictureCanvas.getBoundingClientRect();
    //         }
    //
    //     }
    // }

}
